<template>
  <div class="text-center">
    <h4 class="mb-4 text-white">
      {{ $t('DepositTicket.DepositTicketInformation') }}
    </h4>
    <h5>
      {{ $t('DepositTicket.AvailableBalance') }}:
      {{ parseFloat(balanceResponse.available_balance).toFixed(2) }}
    </h5>
    <h5>
      {{ $t('DepositTicket.AmountAtRisk') }}:
      {{ parseFloat(balanceResponse.amount_at_risk).toFixed(2) }}
    </h5>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('depositTicketStore', ['balanceResponse']),
  },
};
</script>
